import { render, staticRenderFns } from "./ReporteNovedadesHSEIndex.vue?vue&type=template&id=2cae7999"
import script from "./ReporteNovedadesHSEIndex.vue?vue&type=script&lang=js"
export * from "./ReporteNovedadesHSEIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports